import { useTranslation } from 'react-i18next';

import { StatusPill } from '@/components/common';

export type InviteStatus = 'approved' | 'pending' | 'expired';

const statusConfig: Record<InviteStatus, { bg: string; fg: string; labelKey: string }> = {
  approved: {
    bg: 'var(--color-status-success-soft)',
    fg: 'var(--color-status-success)',
    labelKey: 'users.invite.status.approved'
  },
  pending: {
    bg: 'var(--color-status-warning-soft)',
    fg: 'var(--color-status-warning)',
    labelKey: 'users.invite.status.pending'
  },
  expired: {
    bg: 'var(--color-status-danger-soft)',
    fg: 'var(--color-status-danger)',
    labelKey: 'users.invite.status.expired'
  }
};

export const getInviteStatus = (expiresAt: string, usedAt: string | null): InviteStatus => {
  if (usedAt) return 'approved';
  if (new Date(expiresAt).getTime() <= Date.now()) return 'expired';
  return 'pending';
};

export const InviteStatusBadge = ({ status }: { status: InviteStatus }) => {
  const { t } = useTranslation();
  const { bg, fg, labelKey } = statusConfig[status];

  return <StatusPill label={t(labelKey)} bg={bg} fg={fg} />;
};
